import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../shared/utility";


const initialState = []


const setData = (state, action) => {
    const updatedState = JSON.parse(JSON.stringify(state));
    updatedState.push(action.data)
    return updatedState
}

const loadData = (state, action) => {

    return action.data
}

const saveVehicle = (state, action) => {
    const updatedState = JSON.parse(JSON.stringify(state));
    updatedState[action.data.id] = updateObject(updatedState[action.data.id], action.data.data)
    return updatedState
}


const saveVehicles = (state, action) => {
    return action.data.vehicles
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_VEHICLE:
            return setData(state, action);
        case actionTypes.SAVE_VEHICLE:
            return saveVehicle(state, action);
        case actionTypes.SAVE_VEHICLES:
            return saveVehicles(state, action);
        case actionTypes.LOAD_VEHICLE:
            return loadData(state, action);
        default:
            return state;
    }
};

export default reducer;